import { useCallback, useEffect, useRef } from "react"

import { UText } from "@/ui-component"
import { Grid } from "@mui/material"
import { useTranslation } from "react-i18next"
import { DigitalFill } from "./components/DigitalFill"
import { Label } from "./components/Label"
import { PrintOthers } from "./components/PrintOthers"
import { StageNumber } from "./components/StageNumber"
import { TrimLine } from "./components/TrimLine"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { useClinicalSettingsUpdate } from "@/hooks/useClinicalSettingsUpdate"
import { updateStandardModel } from "@/core/app/slices/user/userSlice"

const StandardModel = () => {
  const { t } = useTranslation("common")
  const {
    clinicalSettings: { StandardModel },
  } = useAppSelector((state: RootState) => state.userService)
  const onPrintSettingChange = useClinicalSettingsUpdate()
  const prevStandardModel = useRef(StandardModel)

  // Setup update function
  const updateClinicalSettingsAPI = useCallback(
    (updates: any) => {
      const updatedData = {
        StandardModel: {
          ...updates,
        },
      }
      onPrintSettingChange(updatedData)
    },
    [onPrintSettingChange],
  )

  useEffect(() => {
    // Compare current with previous value using deep comparison
    const currentStr = JSON.stringify(StandardModel)
    const prevStr = JSON.stringify(prevStandardModel.current)
    
    if (prevStr !== currentStr) {
      // Only call API if we have a meaningful previous value (skip initial load)
      if (prevStandardModel.current && Object.keys(prevStandardModel.current).length > 0) {
        updateClinicalSettingsAPI(StandardModel)
      }
      // Update previous value for next comparison
      prevStandardModel.current = StandardModel
    }
  }, [StandardModel, updateClinicalSettingsAPI])
  

  return (
    <Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.stageNumbertitle")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <StageNumber
            currPrint={StandardModel}
            updateModel={updateStandardModel}
          />
        </Grid>
      </Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.label")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <Label
            currPrint={StandardModel}
            updateModel={updateStandardModel}
          />
        </Grid>
      </Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.digitalFill")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <DigitalFill
            currPrint={StandardModel}
            updateModel={updateStandardModel}
          />
        </Grid>
      </Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.trim")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <TrimLine
            currPrint={StandardModel}
            updateModel={updateStandardModel}
          />
        </Grid>
      </Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.others")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <PrintOthers
            exportModel={"StandardModel"}
            currPrint={StandardModel}
            updateModel={updateStandardModel}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default StandardModel
